<template>
	<div class=" enterprisewebsite"  v-title :data-title="msg">
		<headerbar :curindex="curindex"></headerbar>
	 <div class="industrial-list">
			<div class="whitebox centerpage oh">
				<div class="w95mg">
					<div class="floortitle-en bdbe">
						<h2 class="title">装备制造产业环境</h2> 
					</div>
					<div class="indexflex dynamiclist-ind">
						<div class="col4h">
							<h4 class="title">智能推荐</h4>
							<ul>
								<li v-for="list in eventchain">
									<h5 class="fwn onlyline fl">{{list.title}}</h5>
									<p class="stargrade1 stargrade fr"><i class="starfull" v-for="star in list.grade"></i><i class="stargray" v-for="star in (5-list.grade)"></i></p>
								</li>
							</ul>
							<span class="morelink">更多内容>></span>
						</div>
						<div class="col4h">
							<h4 class="title">最新战略</h4>
							<ul>
								<li v-for="list in eventchain">
									<h5 class="fwn onlyline fl">{{list.title}}</h5>
									<p class="stargrade1 stargrade fr"><i class="starfull" v-for="star in list.grade"></i><i class="stargray" v-for="star in (5-list.grade)"></i></p>
								</li>
							</ul>
							<span class="morelink">更多内容>></span>
						</div> 
					</div>  
				</div>
			</div> 
			<div class="whitebox centerpage oh">
				<div class="w95mg">
					<div class="floortitle-en bdbe">
						<h2 class="title">产业专题</h2> 
					</div>
					<div class="indexflex dynamiclist-ind strategic_topic">
						<div class="col4h">
							<h4 class="title">装备制造</h4>
							<ul>
								<li v-for="list in dynamiclist" @click="routerlinkid('/newsTopics',5144)">
									<h5 class="fwn onlyline fl a-router">{{list.title}}</h5>
									<p class="stargrade1 stargrade fr"><i class="starfull" v-for="star in list.grade"></i><i class="stargray" v-for="star in (5-list.grade)"></i></p>
								</li>
							</ul>
							<span class="morelink">更多内容>></span>
						</div>
						<div class="col4h">
							<h4 class="title">新一代信息技术</h4>
							<ul>
								<li v-for="list in dynamiclist1" @click="routerlinkid('/newsTopics',5144)">
									<h5 class="fwn onlyline fl a-router">{{list.title}}</h5>
									<p class="stargrade1 stargrade fr"><i class="starfull" v-for="star in list.grade"></i><i class="stargray" v-for="star in (5-list.grade)"></i></p>
								</li>
							</ul>
							<span class="morelink">更多内容>></span>
						</div>
						<div class="col4h">
							<h4 class="title">汽车产业</h4>
							<ul>
								<li v-for="list in dynamiclist" @click="routerlinkid('/newsTopics',5144)">
									<h5 class="fwn onlyline fl a-router">{{list.title}}</h5>
									<p class="stargrade1 stargrade fr"><i class="starfull" v-for="star in list.grade"></i><i class="stargray" v-for="star in (5-list.grade)"></i></p>
								</li>
							</ul>
							<span class="morelink">更多内容>></span>
						</div>
						<div class="col4h">
							<h4 class="title">生物医药</h4>
							<ul>
								<li v-for="list in dynamiclist1" @click="routerlinkid('/newsTopics',5144)">
									<h5 class="fwn onlyline fl a-router">{{list.title}}</h5>
									<p class="stargrade1 stargrade fr"><i class="starfull" v-for="star in list.grade"></i><i class="stargray" v-for="star in (5-list.grade)"></i></p>
								</li>
							</ul>
							<span class="morelink">更多内容>></span>
						</div>
						<div class="col4h">
							<h4 class="title">新能源</h4>
							<ul>
								<li v-for="list in dynamiclist1" @click="routerlinkid('/newsTopics',5144)">
									<h5 class="fwn onlyline fl a-router">{{list.title}}</h5>
									<p class="stargrade1 stargrade fr"><i class="starfull" v-for="star in list.grade"></i><i class="stargray" v-for="star in (5-list.grade)"></i></p>
								</li>
							</ul>
							<span class="morelink">更多内容>></span>
						</div>
						<div class="col4h">
							<h4 class="title">新材料</h4>
							<ul>
								<li v-for="list in dynamiclist1" @click="routerlinkid('/newsTopics',5144)">
									<h5 class="fwn onlyline fl a-router">{{list.title}}</h5>
									<p class="stargrade1 stargrade fr"><i class="starfull" v-for="star in list.grade"></i><i class="stargray" v-for="star in (5-list.grade)"></i></p>
								</li>
							</ul>
							<span class="morelink">更多内容>></span>
						</div>
					</div>  
				</div>
			</div> 
			<!--  -->
		</div> 
		<footerbar></footerbar>
	</div>
</template>

<script>
	export default {
	  name: 'industriallist2',
	  data(){return{
				msg:"战略管理",
				curindex:3,
				toipsbtn:1,
				dynamiclist:[
					{id:886,title:"孟晚舟回国！中美关系缓和的标志性事件gegedgd",state:"up",grade:4},
					{id:886,title:"孟晚舟回国！中美关系缓和的标志性事件hrrr",state:"up",grade:5},
					{id:886,title:"孟晚舟回国！中美关系缓和的标志性事件gfs ",state:"up",grade:3},
					{id:886,title:"孟晚舟回国！中美关系缓和的标志性事件fdsgdfs",state:"up",grade:5},
					{id:886,title:"孟晚舟回国！中美关系缓和的标志性事件gfk",state:"up",grade:4},
					{id:886,title:"孟晚舟回国！中美关系缓和的标志性事件wee",state:"up",grade:4},
					{id:886,title:"孟晚舟回国！中美关系缓和的标志性事件ghh",state:"up",grade:3},
					{id:886,title:"孟晚舟回国！中美关系缓和的标志性事件ae",state:"up",grade:4},
				],
				dynamiclist1:[
					{id:886,title:"孟晚舟回国！中美关系缓和的标志性事件",state:"down",grade:4},
					{id:886,title:"孟晚舟回国！中美关系缓和的标志性事件jegd",state:"down",grade:5},
					{id:886,title:"孟晚舟回国！中美关系缓和的标志性事件",state:"down",grade:3},
					{id:886,title:"孟晚舟回国！中美关系缓和的标志性事件xrt",state:"down",grade:5},
					{id:886,title:"孟晚舟回国！中美关系缓和的标志性事件",state:"down",grade:4},
					{id:886,title:"孟晚舟回国！中美关系缓和的标志性事件jerexeryg",state:"down",grade:4},
					{id:886,title:"孟晚舟回国！中美关系缓和的标志性事件",state:"down",grade:3},
					{id:886,title:"孟晚舟回国！中美关系缓和的标志性事件hjegy",state:"down",grade:4},
				],
				eventchain:[
					{date:"2021年10月15日",title:'央行：个人收款条码存在一些风险隐患',grade:4},
					{date:"2021年10月15日",title:'央行：个人收款条码存在一些风险隐患',grade:4},
					{date:"2021年10月15日",title:'央行：个人收款条码存在一些风险隐患',grade:4},
					{date:"2021年10月15日",title:'央行：个人收款条码存在一些风险隐患',grade:4},
					{date:"2021年10月15日",title:'央行：个人收款条码存在一些风险隐患',grade:4},
					{date:"2021年10月15日",title:'央行：个人收款条码存在一些风险隐患',grade:4},
					{date:"2021年10月15日",title:'央行：个人收款条码存在一些风险隐患',grade:4},
					{date:"2021年10月15日",title:'央行：个人收款条码存在一些风险隐患',grade:4},
				],
				reportlist:[
					{name:"2021-2025年中国半导体设备行业深度调研及投资前景预测报告",grade:5,type:"综合"},
					{name:"2021-2025年中国半导体设备行业深度调研及投资前景预测报告",grade:5,type:"综合"},
					{name:"2021-2025年中国半导体设备行业深度调研及投资前景预测报告",grade:5,type:"综合",},
					{name:"2021-2025年中国半导体设备行业深度调研及投资前景预测报告",grade:4,type:"综合"},
					{name:"2021-2025年中国半导体设备行业深度调研及投资前景预测报告",grade:4,type:"综合"},
					{name:"2021-2025年中国半导体设备行业深度调研及投资前景预测报告",grade:3,type:"综合"},
					{name:"2021-2025年中国半导体设备行业深度调研及投资前景预测报告",grade:5,type:"综合"},
					{name:"2021-2025年中国半导体设备行业深度调研及投资前景预测报告",grade:2,type:"综合"},
				],
				
			}},
			mounted() {
				this.bus.$emit('loading',false); 
			},
	}
	
	
	
</script>

<style >
	
</style> 
